import React from "react";
import { useApp } from "../../hooks/app-context";
import { RouteConfig } from "../../routes/AuthRoutes";
import { LinkComponent } from "../shared/LinkComponent";
import { TextComponent } from "../shared/TextComponent";
import { useConfig } from "../../hooks/config-context";
import { AzureAdSsoButtonComponent } from "./shared/AzureAdSsoButtonComponent";
import { GoogleSsoButtonComponent } from "./shared/GoogleSsoButtonComponent";
import { useTranslation } from "react-i18next";
const SignupMissingUserComponent = ({
  didClickFederatedSignup,
  federation
}) => {
  const {
    authLegacy
  } = useConfig();
  const {
    azureAdSsoEnabled,
    googleSsoEnabled,
    privacyPolicyUrl,
    termsOfServiceUrl
  } = useApp();
  const {
    t
  } = useTranslation();

  // Show SSO Login btn if we have it enabled
  const azureAdLogin = !authLegacy && azureAdSsoEnabled;
  const googleLogin = !authLegacy && googleSsoEnabled;
  const signupMiddleware = type => {
    didClickFederatedSignup(type);
  };
  const renderSignupAlternatives = () => {
    if (googleLogin && federation === "google") {
      return /*#__PURE__*/React.createElement(GoogleSsoButtonComponent, {
        label: "continue",
        onClick: () => signupMiddleware("google")
      });
    } else if (azureAdLogin && federation === "ms-azure-ad") {
      return /*#__PURE__*/React.createElement(AzureAdSsoButtonComponent, {
        label: "continue",
        onClick: () => signupMiddleware("ms-azure-ad")
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "max-w-sm w-full"
  }, /*#__PURE__*/React.createElement(TextComponent, {
    size: "sm",
    className: "mb-3"
  }, t("By proceeding you agree to the Nblocks"), "\xA0", /*#__PURE__*/React.createElement(LinkComponent, {
    type: "primary",
    to: privacyPolicyUrl,
    nativeBehavior: true,
    target: "_blank",
    size: "sm",
    className: "font-semibold"
  }, t("privacy policy")), "\xA0&\xA0", /*#__PURE__*/React.createElement(LinkComponent, {
    type: "primary",
    to: termsOfServiceUrl,
    nativeBehavior: true,
    target: "_blank",
    size: "sm",
    className: "font-semibold"
  }, t("terms of use"))), renderSignupAlternatives(), /*#__PURE__*/React.createElement("div", {
    className: "mt-8 text-center"
  }, /*#__PURE__*/React.createElement(TextComponent, {
    size: "sm"
  }, t("Or return to"), "\xA0", /*#__PURE__*/React.createElement(LinkComponent, {
    to: RouteConfig.login.loginScreen,
    type: "primary",
    size: "sm",
    className: "font-semibold"
  }, t("login")))));
};
export { SignupMissingUserComponent };